<template>
  <va-card>
    <template slot="header">
      <div class="va-card__header-title" color="secondary">
        <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / {{ $t('menu.settings') }}
      </div>
    </template>
    <form @submit.prevent="onsubmit">
      <div class="row">
        <div class="flex md4 sm6 xs12">
          <va-input
            type="number"
            step="any"
            v-model="form.km_price"
            label="Ekstra km Fiyatı"
            placeholder="Ekstra km fiyatı girin"
            required
          >
            <va-icon
              slot="append"
              color="gray"
              name="fa fa-turkish-lira"
            />
          </va-input>
          <!-- error -->
          <!-- :error-messages="errorMessages" -->
          <!-- :messages="messages" -->
        </div>
      </div>
      <div class="row">
        <va-button type="submit">Kaydet</va-button>
      </div>
    </form>
  </va-card>
</template>

<script>
import settingsServices from '../../services/api/settings'
import responseMixin from '../../services/api/response'
export default {
  mixins: [responseMixin],
  data () {
    return {
      form: {
        km_price: null
      }
    }
  },
  methods: {
    async getSettings(){
      const result = await settingsServices.get();
      if(result.error){
        return ;
      }
      this.form = result.data.data;
    },
    async putSettings() {
      const res = await settingsServices.put({
        data: this.form
      });
      if(res.error){
        //error handling
        this.responseToast('PUT', 'error', res);
        return ;
      }
      this.responseToast('PUT', 'success');
    },
    onsubmit () {
      //validation
      this.putSettings();
    },
  },
  created () {
    this.getSettings();
  },
}
</script>